import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from "@radix-ui/react-dialog";
import { Cross1Icon } from "@radix-ui/react-icons";
import clsx from "clsx";
import type { ReactNode } from "react";

interface DateRangePickerDialogProps {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  triggerNode?: ReactNode;
  contentNode?: ReactNode;
}

export function DateRangePickerDialog({ open, onOpenChange, triggerNode, contentNode }: DateRangePickerDialogProps) {
  return (
    <Dialog open={open} defaultOpen onOpenChange={onOpenChange}>
      <DialogTrigger asChild>{triggerNode}</DialogTrigger>
      <DialogPortal>
        <DialogOverlay asChild>
          <div
            className={clsx(
              "fixed",
              "inset-0",
              "z-20",
              "bg-black",
              "bg-opacity-25",
              `[&[data-state="open"]]:animate-[dialog-overlay-open_ease_150ms_forwards]`,
              `[&[data-state="closed"]]:animate-[dialog-overlay-close_ease_150ms_forwards]`
            )}
          />
        </DialogOverlay>
        <DialogContent asChild>
          <div
            className={clsx(
              "fixed",
              "bottom-0",
              "left-0",
              "right-0",
              "w-full",
              "z-20",
              "rounded-tl-xl",
              "rounded-tr-xl",
              "py-3",
              "bg-white",
              "shadow-elevation-high",
              "min-h-[360px]",
              `[&[data-state="open"]]:animate-[dialog-content-open_ease_150ms_forwards]`,
              `[&[data-state="closed"]]:animate-[dialog-content-close_ease_150ms_forwards]`
            )}
          >
            <div className={clsx("py-2", "px-4")}>
              <div className={clsx("flex", "items-center")}>
                <div className="min-w-0 flex-grow">
                  <DialogTitle className={clsx("text-base", "leading-normal")}>日付を選択</DialogTitle>
                </div>
                <div className="min-w-0">
                  <DialogClose
                    aria-label="ダイアログを閉じる"
                    title="ダイアログを閉じる"
                    className={clsx("min-w-[2rem]", "min-h-[2rem]")}
                  >
                    <Cross1Icon />
                  </DialogClose>
                </div>
              </div>
            </div>
            {contentNode}
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
